import React, {useEffect, useState} from "react";


import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    LinearProgress,
    TextField,
    Theme,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    Slide,
    List,
    ListItem,
    Stepper,
    Step,
    StepLabel
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MonitorIcon from '@mui/icons-material/Monitor';
import {ContainerClasses} from '../../themes/containerClasses'
import {useAuth} from "../../hooks/useAuth";
import {useSnackbar} from "notistack";

export const MFARegisterDialog: React.FC<{
  username: string,
  password: string
}> = ({
  username,
  password
}) => {

  const styles = ContainerClasses();

  const {error, mfaRegister, onMfaRegister, mfaQRCode, isLoading} = useAuth();

  const [otp, setOtp] = useState<string>("");


  const steps = ['Register MFA App', 'Verify OTP'];
  const [activeStep, setActiveStep] = useState<number>(0);
  const [skippedSteps, setSkippedSteps] = useState<number[]>([]);
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);

  const { enqueueSnackbar } = useSnackbar();

  //handle next step
  const handleNext = () => {
     setActiveStep((previousActiveStep) => previousActiveStep+1)
    };

  //handle previous step
  const handlePrevious = () => {
     setActiveStep((previousActiveStep) => previousActiveStep-1)
  };

  const onSubmitMfaOtp = (event: React.MouseEvent<HTMLButtonElement>) => {
    onMfaRegister(otp, username, password)
  };

  useEffect(() => {
    if(error.errorMfaRegister !== ''){
      enqueueSnackbar("MFA code could not be verified", {
        variant: "error",
      });
    }
  }, [error]);


  return (

    <Dialog
          open={mfaRegister}
          onClose={() => {}}
          maxWidth={"lg"}
          fullWidth
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
    >

       <DialogTitle>
          {isLoading && <LinearProgress color="primary" />}
         <Box sx={{mt: '4pt',
                   mb: '4pt'}}>
           <Typography
               color="textSecondary"
               align="center"
             >
               Please register a MFA Authenticator App
             </Typography>
          </Box>
       </DialogTitle>

      <Stepper
         activeStep={activeStep}
         alternativeLabel
         color="primary"
      >
         {steps.map((label) => (
           <Step
              key={label}
              completed = {false}
//              disabled = {false}
           >
              <StepLabel>
                 {label}
              </StepLabel>
          </Step>
         ))
      }
      </Stepper>

      <Box sx={{
        marginTop: "20px",
        marginLeft: "10px",
        marginRight: "10px",
        marginBottom: "10px"
      }}>

     {activeStep === 0 &&
       <>
         <Typography>
           Instructions:
         </Typography>

         <Typography component="ul">
           <li> Download an Authenticator app on your mobile </li>
           <li> Create a new authenticator by scanning the QR code below</li>
           <li> When setup is finished, please proceed further to verify authenticator:
                <Button
                   color="primary"
                   variant="contained"
                   fullWidth
                   disabled={isLoading}
                   onClick={(event) => handleNext()}
                >
                  Verify MFA
                </Button>
           </li>
         </Typography>

         <Box sx={{
           display: "flex",
           justifyContent: "center",
           marginTop: "10px",
           marginBottom: "10px",
           width: '100%'}}>
           <Box
             sx={{
               objectFit: 'cover',
               width: '50%',
               height: 'auto'
             }}
             component="img"
             src={mfaQRCode}
             alt = "QR Code"
             />
         </Box>

       </>
      }

     {activeStep === 1 &&
       <>
         <Typography>
           Please verify your MFA App by providing the code:
         </Typography>

         <Box sx={{
           display: "flex",
           flexDirection: "column",
           justifyContent: "center",
           marginTop: "10px",
           marginBottom: "10px",
           width: '100%'}}>

           <TextField
             fullWidth
             error={false}
             disabled={isLoading}
             size="small"
             label={"Code"}
             variant="filled"
             value={otp}
             onChange={(event) => setOtp(event.target.value)}
           />

           <Box sx={{height: "10px"}} />

         </Box>

         <Box sx={styles.containerRowB}>
            <Button
               color="inherit"
               disabled={isLoading}
               onClick={handlePrevious}
            >
               Back
            </Button>

            <Button
               color="primary"
               variant="contained"
               disabled={isLoading}
               onClick={(event) => onSubmitMfaOtp(event)}
            >
               Verify
            </Button>

          </Box>



       </>
     }



      </Box>

    </Dialog>


  );

};
